import type { FC } from "react";

import { Modal } from "@aviary";
import { useFlippers } from "@shared/hooks";
import { Routes, Route } from "@shared/react-router-dom";
import { Size } from "@shared/types/sizes";
import { wildcardPath } from "@shared/utils";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { PatientRxBackground, StoreLandingLayout } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

import { RxSignInModalMain } from "./PatientRxSignInModal";
import { RxSignInForgotPassword } from "./PatientRxSignInModal/RxSignInForgotPassword";

interface Props {
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  newSSOErrors?: string;
}

const PatientRxSignInPage: FC<Props> = ({
  patientAttributes,
  additionalAttributes,
  newSSOErrors,
}) => {
  const [isPatientStoreLandingPageEnabled] = useFlippers("titan_patient_store_landing_page");
  const rxSignIn = (
    <StoreLandingLayout
      pracName={patientAttributes.pracName}
      pracAvatar={patientAttributes.pracAvatar}
    >
      <RxSignInModalMain
        patientAttributes={patientAttributes}
        additionalAttributes={additionalAttributes}
        newSSOErrors={newSSOErrors}
        hideExistingAccountCheck
      />
    </StoreLandingLayout>
  );

  const rxSignInModal = (
    <PatientRxBackground>
      <Modal isOpen hideClose isSize={Size.MEDIUM}>
        <Routes>
          <Route
            path={authRoutes.rx_sign_in_forgot_password()}
            element={<RxSignInForgotPassword />}
          />
          <Route
            path={wildcardPath(authRoutes.rx_sign_in)}
            element={
              <RxSignInModalMain
                patientAttributes={patientAttributes}
                additionalAttributes={additionalAttributes}
                newSSOErrors={newSSOErrors}
              />
            }
          />
        </Routes>
      </Modal>
    </PatientRxBackground>
  );

  return isPatientStoreLandingPageEnabled ? rxSignIn : rxSignInModal;
};

export { PatientRxSignInPage };
